import type { RouteObject } from 'react-router';

import { teamWebhookRoutes } from './teams/[teamId]/webhooks/routes.js';
import { ApplicationLayoutConnector } from '../connectors/ApplicationLayoutConnector/ApplicationLayoutConnector.js';
import { loader } from '../app/session.loader.js';
import { PublicLayout } from '../components/PublicLayout/PublicLayout.js';
import { webhookRoutes } from './settings/webhooks/routes.js';
export const pageRoutes: RouteObject[] = [
  {
    Component: PublicLayout,
    children: [
      { path: 'sign-in', lazy: () => import('./sign-in/page.js') },
      { path: 'account/contacts/verify', lazy: () => import('./account/contacts/verify/page.js') },
    ],
  },
  {
    Component: ApplicationLayoutConnector,
    loader,
    children: [
      { index: true, lazy: () => import('./page.js') },
      { path: 'incidents', lazy: () => import('./incidents/page.js') },
      { path: 'incidents/:incidentId', lazy: () => import('./incidents/[incidentId]/page.js') },
      { path: 'on-call', lazy: () => import('./on-call/page.js') },
      {
        path: 'settings',
        lazy: () => import('./settings/page.js'),
        children: [
          ...webhookRoutes,
          {
            path: 'notification-policies',
            lazy: () => import('./settings/notification-policies/page.js'),
          },
          {
            path: 'notification-policies/new',
            lazy: () => import('./settings/notification-policies/new/page.js'),
          },
          {
            path: 'notification-policies/:policyId',
            lazy: () => import('./settings/notification-policies/[policyId]/page.js'),
          },
          { index: true, lazy: () => import('./settings/index/page.js') },
          { path: 'contacts', lazy: () => import('./account/contacts/page.js') },
          { path: 'users', lazy: () => import('./admin/access/users/page.js') },
          { path: 'users/:userId', lazy: () => import('./admin/access/users/[userId]/page.js') },
          { path: 'access/sessions', lazy: () => import('./admin/access/sessions/page.js') },
          { path: 'customers', lazy: () => import('./admin/customers/page.js') },
          {
            path: 'customers/:customerId',
            lazy: () => import('./admin/customers/[customerId]/page.js'),
          },
          { path: 'audit/authentication', lazy: () => import('./admin/access/audit/page.js') },
          {
            path: 'audit/customer-activity',
            lazy: () => import('./admin/customers/activity/page.js'),
          },
        ],
      },
      { path: 'teams', lazy: () => import('./teams/page.js') },
      {
        path: 'teams/:teamId',
        lazy: () => import('./teams/[teamId]/page.js'),
        children: [
          { index: true, lazy: () => import('./teams/[teamId]/index/page.js') },
          ...teamWebhookRoutes,
          { path: 'escalations', lazy: () => import('./teams/[teamId]/escalations/page.js') },
          {
            path: 'escalations/new',
            lazy: () => import('./teams/[teamId]/escalations/new/page.js'),
          },
          {
            path: 'escalations/:policyId',
            lazy: () => import('./teams/[teamId]/escalations/[policyId]/page.js'),
          },
          { path: 'members', lazy: () => import('./teams/[teamId]/members/page.js') },
          { path: 'settings', lazy: () => import('./teams/[teamId]/settings/page.js') },
          {
            path: 'schedules',
            lazy: () => import('./teams/[teamId]/schedules/page.js'),
            children: [
              { path: 'new', lazy: () => import('./teams/[teamId]/schedules/new/page.js') },
              {
                path: ':scheduleId/settings',
                lazy: () => import('./teams/[teamId]/schedules/settings/page.js'),
              },
              {
                path: ':scheduleId/archive',
                lazy: () => import('./admin/schedules/[scheduleId]/archive/page.js'),
              },
              {
                path: ':scheduleId/routines/new',
                lazy: () => import('./teams/[teamId]/schedules/routines/new/page.js'),
              },
              {
                path: ':scheduleId/routines/:routineId/edit',
                lazy: () =>
                  import('./admin/schedules/[scheduleId]/routines/[routineId]/edit/page.js'),
              },
              {
                path: ':scheduleId/routines/:routineId/overrides/new',
                lazy: () =>
                  import('./admin/schedules/[scheduleId]/routines/[routineId]/overrides/page.js'),
              },
              {
                path: ':scheduleId/routines/:routineId/overrides/:overrideId',
                lazy: () =>
                  import('./admin/schedules/[scheduleId]/routines/[routineId]/overrides/page.js'),
              },
            ],
          },
        ],
      },
      { path: 'schedules/:scheduleId', lazy: () => import('./schedules/[scheduleId]/page.js') },
      {
        path: 'schedules/:scheduleId/routines/:routineId',
        lazy: () => import('./schedules/[scheduleId]/routines/[routineId]/page.js'),
      },
    ],
  },
];
